import React from "react";
import Grid from "@material-ui/core/Grid";
import Layout from "../../Layout";
import Button from "@material-ui/core/Button";
import PersonIcon from "@material-ui/icons/Person";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import googleAnalytics from "fuction/googleAnalytics";

export default function UserSetting(props) {
  React.useEffect(() => {
    googleAnalytics(props.location.pathname);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Grid>
          <Grid item>
            <Button startIcon={<PersonIcon />} href="/config/password">
              パスワード変更
            </Button>
          </Grid>
          <Grid item>
            <Button startIcon={<MailOutlineIcon />} href="/config/dtm">
              メール送信先設定
            </Button>
          </Grid>
        </Grid>
      }
    />
  );
}
